module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "cove.ce031afa.svg";